(function () {
  if (window.lopPlpPriceSort) return;
  window.lopPlpPriceSort = true;

  var timer = 0;

  function sortDir() {
    var params = new URLSearchParams(window.location.search);
    var sort = params.get('sort_by');
    var grid;

    if (!sort) {
      grid = document.getElementById('product-grid');
      sort = grid && grid.getAttribute('data-lop-sort-by');
    }

    if (sort === 'price-ascending') return 1;
    if (sort === 'price-descending') return -1;
    return 0;
  }

  function isProductItem(node) {
    return !!(node && node.matches && node.matches('li.columns') && node.querySelector('product-card[data-lop-sort-price]'));
  }

  function priceOf(item) {
    var card = item.querySelector('product-card[data-lop-sort-price]');
    return parseInt(card.getAttribute('data-lop-sort-price'), 10) || 0;
  }

  function applySort(grid, dir) {
    var slots = Array.prototype.slice.call(grid.children).filter(isProductItem);
    var sorted = slots.slice().sort(function (a, b) {
      return (priceOf(a) - priceOf(b)) * dir;
    });
    var marks = [];
    var i;
    var mark;

    if (!slots.length) return;

    for (i = 0; i < slots.length; i += 1) {
      mark = document.createElement('li');
      mark.setAttribute('data-lop-sort-slot', '1');
      slots[i].replaceWith(mark);
      marks.push(mark);
    }

    for (i = 0; i < sorted.length; i += 1) {
      marks[i].replaceWith(sorted[i]);
    }
  }

  function run() {
    var dir = sortDir();
    var grid = document.getElementById('product-grid');

    if (!dir || !grid) return;
    applySort(grid, dir);
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, 40);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('lop:product-grid-updated', schedule);

  if (document.readyState !== 'loading') schedule();

  function watch() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || container.dataset.lopPriceSortWatch) return;
    container.dataset.lopPriceSortWatch = '1';
    new MutationObserver(schedule).observe(container, { childList: true });
  }

  watch();
  document.addEventListener('lop:product-grid-updated', watch);
})();
